import {type Dispatch, type SetStateAction, useEffect} from "react";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";

import {clear as clearConstruction} from "../../constructionNew/constructionNewSlice";
import {clear as clearConstructionCalculations} from "../../constructionCalculationsNew/constructionCalculationsNewSlice";

/**
 * Trigger the initial page data load on mount and clean up Redux state on unmount.
 */
const useConstructionCalculationsLifecycleHook = (
  loadPageData: (selectedCalculationId?: string | null) => Promise<void>,
  setLoading: Dispatch<SetStateAction<boolean>>,
  initialCalculationId: string | undefined,
): void => {
  const dispatch = useDispatch();
  const {id} = useParams();

  useEffect(() => {
    void (async () => {
      setLoading(true);
      await loadPageData(initialCalculationId);
      setLoading(false);
    })();

    return () => {
      dispatch(clearConstruction());
      dispatch(clearConstructionCalculations());
    };
  }, [dispatch, id, initialCalculationId, loadPageData, setLoading]);
};

export default useConstructionCalculationsLifecycleHook;
